<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container">
    <ion-row>
      <ion-col>
        <app-modal-header
          header="{{ 'FLOOR.NEW_FLOOR' | translate }}"
          (close)="close()"
        >
        </app-modal-header>

        <form
          [formGroup]="form"
          (ngSubmit)="Save()"
          class="add-company-floor__form-container"
        >
          <div class="control-display">
            <ion-label>{{'COMMUNITY.BUILDING' | translate}}</ion-label>
            <app-select-dropdown
              [data]="buildingService.buildings"
              (changeValueEvent)="onChangeBuilding($event)"
              formControlName="building"
            ></app-select-dropdown>
          </div>

          <div class="control-display">
            <ion-label>{{'COMPANY_FLOOR.FLOORS' | translate }}*</ion-label>
            <app-select-dropdown
              #floorDropdown
              [data]="companyServ.companyFloors"
              formControlName="floors"
              multiple="true"
              (touchEvent)="onSelectTouched('floors')"
            ></app-select-dropdown>
          </div>

          <ion-label
            *ngIf="
                      form.get('floors').hasError('required') &&
                      (form.get('floors').touched || validationError)
                    "
            color="danger"
            class="font-size__16"
          >
            {{ "SPACE.REQUIRED_VALIDATION" | translate }}
          </ion-label>

          <ion-item class="input" lines="none">
            <ion-button
              type="submit"
              class="button-margin-top-md"
              size="medium"
              slot="end"
              >{{'SAVE' | translate}}
            </ion-button>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
